var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMsExcel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5259_88442)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 2,
    width: 24,
    height: 28,
    rx: 2,
    fill: "#2FB776"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 23H32.5V28C32.5 29.1046 31.6046 30 30.5 30H10.5C9.39543 30 8.5 29.1046 8.5 28V23Z",
    fill: "url(#paint0_linear_5259_88442)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.5,
    y: 16,
    width: 12,
    height: 7,
    fill: "#229C5B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.5,
    y: 9,
    width: 12,
    height: 7,
    fill: "#27AE68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 4C8.5 2.89543 9.39543 2 10.5 2H20.5V9H8.5V4Z",
    fill: "#1D854F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 9,
    width: 12,
    height: 7,
    fill: "#197B43"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 16,
    width: 12,
    height: 7,
    fill: "#1B5B38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 12C8.5 10.3431 9.84315 9 11.5 9H17.5C19.1569 9 20.5 10.3431 20.5 12V24C20.5 25.6569 19.1569 27 17.5 27H8.5V12Z",
    fill: "black",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 7,
    width: 18,
    height: 18,
    rx: 2,
    fill: "url(#paint1_linear_5259_88442)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 21L10.6821 15.9L13.3763 11H11.177L9.51375 14.1286L7.87801 11H5.60997L8.31787 15.9L5.5 21H7.69931L9.47251 17.6857L11.232 21H13.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5259_88442",
    x1: 8.5,
    y1: 26.5,
    x2: 32.5,
    y2: 26.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#163C27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A6043"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5259_88442",
    x1: 0.5,
    y1: 16,
    x2: 18.5,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#185A30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#176F3D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5259_88442"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMsExcel);
export default __webpack_public_path__ + "static/media/MsExcel.d31e59232f1d480ac2e18d72b0e669f3.svg";
export { ForwardRef as ReactComponent };